/**
 * Format date to locale string (Indonesian)
 * @param dateString ISO date string
 * @returns Formatted date string (e.g., "19 Maret 2025")
 */
export function formatDate(dateString: string): string {
  if (!dateString) return "";

  const date = new Date(dateString);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
}

/**
 * Helper function to build share URLs for different platforms
 * @param activity Activity to share
 * @returns Object with URLs for different sharing platforms
 */
export function getShareUrls(title: string, desc?: string) {
  if (typeof window === "undefined") {
    return {
      whatsapp: "",
      facebook: "",
      twitter: "",
    };
  }

  const currentUrl = window.location.href;
  const encodedUrl = encodeURIComponent(currentUrl);
  const encodedTitle = encodeURIComponent(title);
  const encodedText = encodeURIComponent(`Jadi relawan untuk "${title}"`);

  return {
    whatsapp: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
  };
}

/**
 * Build WhatsApp message URL for contacting organizer
 * @param activity Activity with contact information
 * @returns WhatsApp URL with pre-filled message
 */
export function getWhatsAppOrganizerUrl(activity: DetailActivity): string {
  const message = encodeURIComponent(
    `Halo ${activity.contactInfo.name}, saya tertarik dengan kegiatan "${activity.title}". Bisakah Anda memberikan informasi lebih lanjut?`,
  );

  return `https://wa.me/${activity.creatorPhoneNo}?text=${message}`;
}

/**
 * Share content using the Web Share API
 * @param title Title to share
 * @param text Text description to share
 * @param url URL to share
 * @returns Promise resolving to boolean indicating if share was successful
 */
export async function shareViaWebShare(
  title: string,
  text: string,
  url: string,
): Promise<boolean> {
  if (typeof navigator === "undefined" || !navigator.share) {
    return false;
  }

  try {
    await navigator.share({
      title,
      text,
      url,
    });
    return true;
  } catch (error) {
    // User cancelled or share failed
    console.error("Error sharing:", error);
    return false;
  }
}
